<template>
  <div>
    <HeadBar @nameClick = "nameClick"></HeadBar>
    <div class="conent-box">
      <div class="initial-search">
        <span style="color:#EE5223;font-size: 16px;">身份证件号码：</span>
        <el-input type="text" v-model="form.certNo" auto-complete="off" maxlength="18"
                  @clear="changeInfoVal" @change="changeInfoVal" clearable></el-input>
        <i class="fa fa-search" @click="serachInfo"></i>
      </div>
      <div v-if="personShow">
        <div v-if="searchPersonShow">
          <div class="initial-div">
            <div><span>身份证号：</span><span>{{personForm.certNo}}</span></div>
            <div><span>所属公司：</span><span>{{personForm.companyName}}</span></div>
          </div>
          <p v-if="initialSuccess" style="color:#f00;">该员工密码已经初始为：{{initialVal}}，请员工登录后重设密码！</p>
          <el-button type="primary" @click.native.prevent="InitialPass"  class="initial-btn">密码初始化</el-button>
        </div>
        <div class="initial-div" v-if="!searchPersonShow">
          查无此人！
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import HeadBar from '@/components/HeadBar';
  export default {
    name: 'Initial',
    components:{
        HeadBar
    },
    data() {
        return {
            companyOneId:'', //当前公司信息
            personShow:false,  //搜索成功后再展示个人信息
            searchPersonShow:false,  //搜索后若查到数据展示个人信息
            initialSuccess:false, //初始化成功后显示
            form:{},  //搜索参数
            personForm:{},
            initialVal:'' //初始化成功的初始密码
        }
    },
    methods: {
        // 切换公司
        nameClick:function (data) {
            sessionStorage.setItem('companyChange',JSON.stringify(data));
        },
        // 修改输入框内容时
        changeInfoVal(){
            this.personShow = false;
            this.initialSuccess = false;
            this.initialVal = '';
        },
        // 点击搜索
        serachInfo(){
            if(!this.form.certNo){
                this.$message.error('请输入有效证件号码！')
                return false;
            }
            var that = this;
            this.form.companyId = that.companyOneId.id;
            this.$api.login.retrieveUser(this.form).then(res => {
                this.personShow = true;
                if (res.status) {
                    this.searchPersonShow = true;
                    this.initialSuccess = false;
                    this.initialVal = '';
                    this.personForm = res.data;
                }else{
                    this.searchPersonShow = false;
                    this.$message({message: '搜索失败！' + res.msg, type: 'error'})
                }
            })
        },
        // 密码初始化
        InitialPass() {
            var that = this;
            this.$confirm('确认要初始化用户密码吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.form.companyId = that.companyOneId.id;
                this.$api.login.resetPassWord(this.form).then(res => {
                    if (res.status) {
                        this.initialSuccess = true;
                        this.initialVal = res.data;
                        this.$message({message: '密码初始化成功！' , type: 'success'})
                    }else{
                        this.$message({message: '密码初始化失败！' + res.msg, type: 'error'})
                    }
                })
            })
        },
    },
    created() {
      let that = this;
      document.onkeypress = function(e) {
        var keycode = document.all ? event.keyCode : e.which;
        if (keycode === 13) {
          that.InitialPass();
          return false;
        }
      };
    },
    mounted() {
        var that = this;
        window.addEventListener('setItemEvent',function(e){
            if(e.key == "companyChange"){
                that.companyOneId = JSON.parse(e.newVal);
            }else if(e.key == "companyOneId"){
                that.companyOneId = JSON.parse(e.newVal);
            }
        });
    },
    computed:{}
  }
</script>

<style lang="scss" scoped>
  .initial-search{
    width:450px;
    position:relative;
    text-align:left;
    margin: 60px auto;
  }
  .initial-search i{
    position: absolute;
    right:0;
    top: 50%;
    -ms-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
  }
  .initial-search .el-input{
    width:300px;
  }
  .initial-div div{
    font-size:16px;
    line-height:64px;
    color:#333;
  }
  .initial-div div span:nth-child(2){
    display:inline-block;
    min-width:216px;
    text-align: left;
    line-height:24px;
  }
  /*按钮*/
  .initial-btn{
    margin-top:40px;
  }
</style>




// WEBPACK FOOTER //
// src/views/Initial.vue